type LogoVariant = "default" | "white";

type LogoProps = {
  variant?: LogoVariant;
  className?: string;
  style?: React.CSSProperties;
  /** When set, renders this URL instead of the default sanctions logo. */
  overrideSrc?: string;
};

export function Logo({
  variant = "default",
  className = "h-6 w-auto",
  style,
  overrideSrc,
}: LogoProps) {
  const src =
    overrideSrc ?? (variant === "white" ? "/brand/logo-white.svg" : "/brand/logo-default.svg");
  return <img src={src} alt="sanctions.io" className={className} style={style} />;
}
